export const enum Tasks {
  start = '0',
  missedGates = '1',
  checkpoints = '2'
}
